import { IconButton, styled } from '@ltvco/refresh-lib/theme';

export const StyledClearIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.contrastText,
  backgroundColor: theme.palette.text.secondary,
  borderRadius: '50%',
  position: 'absolute',
  right: 8,
  top: '50%',
  transform: 'translateY(-50%)',

  '&:hover': {
    backgroundColor: theme.palette.text.secondary,
  },
}));
